/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs
*/
import topBarMenuLinkData from './top-bar-menu-link-data';
import dropDownMenuLinkData from './dropdown-menu-link-data';

module.exports = {
  topBarMenuLinkData,
  dropDownMenuLinkData,
};
